<form id="auth-form" [formGroup]="form">
    <aa-input-new-pswd
        [required]="'required'"
        name="password"
        label="Saisissez votre nouveau mot de passe"
        formControlName="password"
    >
    </aa-input-new-pswd>
    <aa-input-password
        [required]="'required'"
        name="verifyPassword"
        label="Saisissez à nouveau votre mot de passe"
        formControlName="verifyPassword"
    >
    </aa-input-password>
</form>
